function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M91.5,157.3q-11.85,15.49,2.6,28.4L244.3,315l-72-166.9-28.8-24.75q-14.9-12.25-27.3,2.8L91.5,157.3m91-87.6q-17.15,8.51-9.75,26.75l83.9,194.35.15-.25,3.05-189.4L243.5,63.25q-8.15-17.89-25.6-10.15L182.5,69.7M352.35,46.35q-4.65-4.1-13-4.45l-38.85-.6q-9.49.11-14.45,5.05T280.8,61.1l-3.1,191.7,79.95-144.45.65-45.8q0-11.1-5.95-16.2M460,87.75,426.35,67.5Q409.7,57.95,399.9,75L266.6,315.6q-4.8,9.19-2.55,16.4,2,6.4,9.65,11.2l33.55,20.25a22.68,22.68,0,0,0,11.2,3.45q7.1-.11,12.45-6.65a34.63,34.63,0,0,0,2.9-4.2L467,115.35Q476.15,98,460,87.75M296.75,333.6a18.71,18.71,0,0,1-5.15-13.25,18.36,18.36,0,0,1,5.15-13.15,17.11,17.11,0,0,1,12.7-5.5,16.85,16.85,0,0,1,12.65,5.5,18.23,18.23,0,0,1,5.2,13.15,18.58,18.58,0,0,1-5.2,13.25,17,17,0,0,1-12.65,5.4A17.28,17.28,0,0,1,296.75,333.6Z",
  transform: "translate(-86.16 -10)",
  fill: "{color}"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 384 384"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pantone.7a38635b.svg";
export { SvgComponent as ReactComponent };